import { Text } from 'preact-i18n';
import { Link } from 'preact-router/match';
import DeviceConfigurationLink from '../../../../components/documentation/DeviceConfigurationLink';

const TeslaPage = props => (
  <div class="page">
    <div class="page-main">
      <div class="my-3 my-md-5">
        <div class="container">
          <div class="row">
            <div class="col-lg-3">
              <h3 class="page-title mb-5">
                <Text id="integration.tesla.title" />
              </h3>
              <div>
                <div class="list-group list-group-transparent mb-0">
                  <Link
                    href="/dashboard/integration/device/tesla"
                    activeClassName="active"
                    class="list-group-item list-group-item-action d-flex align-items-center"
                  >
                    <span class="icon mr-3">
                      <i class="fe fe-link" />
                    </span>
                    <Text id="integration.tesla.deviceTab" />
                  </Link>

                  <Link
                    href="/dashboard/integration/device/tesla/discover"
                    activeClassName="active"
                    class="list-group-item list-group-item-action d-flex align-items-center"
                  >
                    <span class="icon mr-3">
                      <i class="fe fe-radio" />
                    </span>
                    <Text id="integration.tesla.discoverTab" />
                  </Link>

                  <Link
                    href="/dashboard/integration/device/tesla/setup"
                    activeClassName="active"
                    class="list-group-item list-group-item-action d-flex align-items-center"
                  >
                    <span class="icon mr-3">
                      <i class="fe fe-sliders" />
                    </span>
                    <Text id="integration.tesla.setupTab" />
                  </Link>

                  <DeviceConfigurationLink
                    user={props.user}
                    configurationKey="integrations"
                    documentKey="tesla"
                    linkClass="list-group-item list-group-item-action d-flex align-items-center"
                  >
                    <span class="icon mr-3">
                      <i class="fe fe-book-open" />
                    </span>
                    <Text id="integration.tesla.documentation" />
                  </DeviceConfigurationLink>
                </div>
              </div>
            </div>
            <div class="col-lg-9">{props.children}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default TeslaPage;
